import { Box, Paper, Typography, Autocomplete, TextField, InputAdornment, Button } from "@mui/material"
import { useEffect, useState } from "react"
import { useToast } from "../../basecomp/components/provider/ToastProvider"
import { GetTools } from "../model/generalApiCalls"

// Icons matching the design
import NumbersIcon from '@mui/icons-material/Numbers';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import GridViewIcon from '@mui/icons-material/GridView';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';

// CONAS Brand Colors
const CONAS_BLUE = "#163672";
const CONAS_GREEN = "#69b244";

const FormLabel = ({ text }) => (
    <Typography variant="body2" sx={{ fontWeight: 600, color: "#111827", mb: 0.8, fontSize: "0.85rem" }}>
        {text}
    </Typography>
);

function FilterView({ filterData, setFilterData, handelFilterSubmitClick, usertype, handelFilterClearClick }) {
    const [toolsData, setToolsData] = useState(null)
    const { handleToastOpen } = useToast()

    const handelOnchange = (field, value) => {
        setFilterData(prev => ({ ...prev, [field]: value }))
    }

    useEffect(() => {
        const getTools = async () => {
            try {
                let response = await GetTools()
                let newData = Array.from(response.data).map((elem) => elem.title)
                setToolsData(newData)
            } catch (error) { 
                handleToastOpen("error", "Something went wrong in getting tools") 
            }
        }
        getTools()
    }, [handleToastOpen])

    const inputStyles = {
        "& .MuiOutlinedInput-root": { 
            borderRadius: "8px", 
            backgroundColor: "#ffffff",
            "&.Mui-focused fieldset": {
                borderColor: CONAS_BLUE
            }
        }
    };

    return (
        <Paper elevation={0} sx={{ p: 3, borderRadius: "12px", border: "1px solid #e2e8f0", backgroundColor: "#ffffff", boxShadow: "0 4px 20px rgba(0,0,0,0.02)" }}>
            <Box sx={{
                display: "grid",
                gridTemplateColumns: { xs: "1fr", md: "repeat(3, 1fr)" },
                gap: 3
            }}>
                {/* 1. Ticket ID */}
                <Box>
                    <FormLabel text="Ticket Id" />
                    <TextField fullWidth size="small" placeholder="Enter ticket id" value={filterData.ticketId || ""} onChange={(e) => handelOnchange("ticketId", e.target.value)} sx={inputStyles}
                        InputProps={{ startAdornment: <InputAdornment position="start"><NumbersIcon sx={{ color: CONAS_BLUE, fontSize: 18 }} /></InputAdornment> }} />
                </Box>

                {/* 2. Ticket Heading */}
                <Box>
                    <FormLabel text="Ticket Heading" />
                    <TextField fullWidth size="small" placeholder="Enter ticket heading" value={filterData.ticketHeading || ""} onChange={(e) => handelOnchange("ticketHeading", e.target.value)} sx={inputStyles}
                        InputProps={{ startAdornment: <InputAdornment position="start"><ArticleOutlinedIcon sx={{ color: CONAS_BLUE, fontSize: 18 }} /></InputAdornment> }} />
                </Box>

                {/* 3. Ticket Status - ONLY visible to "User" */}
                {usertype === "User" && (
                    <Box>
                        <FormLabel text="Ticket Status" />
                        <Autocomplete size="small" options={["Pending", "Assigned", "Started", "Resolved"]} value={filterData.ticketStatus || null} onChange={(e, val) => handelOnchange("ticketStatus", val)}
                            renderInput={(params) => <TextField {...params} placeholder="Select status" sx={inputStyles} />} />
                    </Box>
                )}

                {/* 4. Ticket Tool */}
                <Box>
                    <FormLabel text="Ticket Tool" />
                    <Autocomplete size="small" options={toolsData || []} value={filterData.ticketTool || null} onChange={(e, val) => handelOnchange("ticketTool", val)}
                        renderInput={(params) => (
                            <TextField {...params} placeholder="Select tool" sx={inputStyles} 
                                InputProps={{ ...params.InputProps, startAdornment: (<><InputAdornment position="start" sx={{ pl: 1 }}><GridViewIcon sx={{ color: CONAS_BLUE, fontSize: 18 }} /></InputAdornment>{params.InputProps.startAdornment}</>) }}
                            />
                        )} />
                </Box>

                {/* 5. Ticket Type */}
                <Box>
                    <FormLabel text="Ticket Type" />
                    <Autocomplete size="small" options={["Improvement", "Bug", "IT Tool Access"]} value={filterData.ticketType || null} onChange={(e, val) => handelOnchange("ticketType", val)}
                        renderInput={(params) => (
                            <TextField {...params} placeholder="Select type" sx={inputStyles} 
                                InputProps={{ ...params.InputProps, startAdornment: (<><InputAdornment position="start" sx={{ pl: 1 }}><LocalOfferIcon sx={{ color: CONAS_BLUE, fontSize: 18 }} /></InputAdornment>{params.InputProps.startAdornment}</>) }}
                            />
                        )} />
                </Box>

                {/* 6. Ticket Date */}
                <Box>
                    <FormLabel text="Ticket Date" />
                    <TextField fullWidth size="small" type="date" value={filterData.ticketDate || ""} onChange={(e) => handelOnchange("ticketDate", e.target.value)} sx={inputStyles} 
                        InputProps={{ startAdornment: <InputAdornment position="start"><CalendarMonthIcon sx={{ color: CONAS_BLUE, fontSize: 18 }} /></InputAdornment> }}
                    />
                </Box>
            </Box>

            {/* Actions aligned to bottom left */}
            <Box sx={{ display: "flex", gap: 2, mt: 3 }}>
                <Button variant="contained" startIcon={<FilterAltIcon />} onClick={handelFilterSubmitClick} 
                    sx={{ bgcolor: CONAS_BLUE, borderRadius: "8px", textTransform: "none", fontWeight: 600, px: 3, boxShadow: "none", "&:hover": { bgcolor: "#112a59", boxShadow: "none" } }}>
                    APPLY FILTERS
                </Button>
                <Button variant="outlined" startIcon={<DeleteOutlineIcon />} onClick={handelFilterClearClick} 
                    sx={{ color: CONAS_BLUE, borderColor: CONAS_BLUE, borderRadius: "8px", textTransform: "none", fontWeight: 600, px: 3, "&:hover": { backgroundColor: "#eef2ff", borderColor: "#112a59" } }}>
                    CLEAR FILTERS
                </Button>
            </Box>
        </Paper>
    )
}

export default FilterView;